import React, { useState, useEffect, useContext } from 'react';
import {
    Grid,
    Button,
    Typography,
    TextField
} from '@material-ui/core';
import { useSelector, useDispatch } from "react-redux";
import AlertDialog from '../components/AlertDialog';
import { language } from 'config';
import { makeStyles } from '@material-ui/core/styles';
import { FirebaseContext } from 'common';
import MaterialTable from 'material-table';
import CircularLoading from "../components/CircularLoading";

export default function SuperDistances() {
    const { api } = useContext(FirebaseContext);
    const {
        GetDistance,
    } = api;
    const columns =  [
        { title: "Rider FullName",field: 'fullname'},
        { title: "Has drivers", field: 'has_driver',type:'boolean', initialEditValue: false },
        { title: "Within range drivers number", field: 'drivers_cnt' },
    ];

  const [data, setData] = useState([]);
  const [title, setTitle] = useState("Table of drivers number within range");
  const usersdata = useSelector(state => state.usersdata);
  const settingsdata = useSelector(state => state.settingsdata);
  useEffect(() => {
    if(data){
        let ridershasdrivers = data.filter(rider => rider.has_driver);
        let ridershasnodrivers = data.filter(rider => !rider.has_driver);
        let newtitle = "Range Table ( Riders who has drivers at least one : " +  ridershasdrivers.length + ", Riders who has no drivers : " + ridershasnodrivers.length + " )";
        setTitle(newtitle) ;
    }
  },[data])
  useEffect(()=>{
        if(usersdata.users){
            let drivers = usersdata.users.filter(user => user.usertype ==='driver' && user.approved === true && user.driverActiveStatus === true && user.location);
            let riders = usersdata.users.filter(user => user.usertype ==='rider' && user.location);
            let newdata = [];
            let temp = {};
            let distance = 0;
            for(var i = 0;i < riders.length;i++){
                temp = {};
                temp.fullname = riders[i].firstName + " " + riders[i].lastName;
                temp.has_driver = false;
                temp.drivers_cnt = 0;
                temp.drivers = [];
                for(var j = 0;j < drivers.length;j++){
                        distance = GetDistance(riders[i].location.lat, riders[i].location.lng, drivers[j].location.lat, drivers[j].location.lng);
                        if(distance <= settingsdata.settings.radius ){
                            temp.has_driver = true;
                            temp.drivers_cnt++;
                            temp.drivers.push(drivers[j]);
                        }
                }
                newdata.push(temp);
            }
            setData(newdata);
        }
  },[usersdata.users]);

  return (
    usersdata.loading? <CircularLoading/>:
    <MaterialTable
      title={title}
      columns={columns}
      data={data}
      options={{
        exportButton: true,
        pageSizeOptions: [5,10,20,100,500,1000,5000]
      }}
      
    />
  );
}